import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import * as React from 'react';

const VIMEO_RE = /\[vimeo (\w+) (\d+) (\d+)\]/;

// Input: "[vimeo 244990099 640 360]"
// Output: <iframe src="https://player.vimeo.com/video/244990099" width="640" height="360" frameborder="0" allowfullscreen />

export const vimeoize = (text: TextLike, remove: boolean = false) => reactFilter(text, (s: string): React.ReactChild[] => {
    const ret = [];
    const matcher = new RegExp(VIMEO_RE, 'g');
    let from = 0;
    while (true) {
        const match = matcher.exec(s);
        if (match) {
            const matchLen = match[0].length;
            const code = match[1];
            const width = match[2];
            const height = match[3];

            const to = matcher.lastIndex - matchLen;

            // copy text before this link
            ret.push(s.substring(from, to));

            const src = `https://player.vimeo.com/video/${code}`;

            // insert embedded vimeo iframe
            if (!remove) {
                ret.push((
                    <iframe
                        width={width}
                        height={height}
                        src={src}
                        frameBorder="0"
                        allowFullScreen
                    />
                ));
            }

            from = matcher.lastIndex;
        } else {
            // copy text after last link
            ret.push(s.substring(from));
            break;
        }
    }
    return ret;
});

export const devimeoize = (text: TextLike) => vimeoize(text, true);
